import styled from "styled-components";
import WithDirection from "@iso/lib/helpers/rtl";

const HealthSafetyWrapper = styled.div`
 .leaflet-container.leaflet-touch.leaflet-fade-anim.leaflet-grab.leaflet-touch-drag.leaflet-touch-zoom{
  border-radius : 8px;
 }
 .map-container{
  height:600px;
  border-radius:8px;
 }
 /* Weather Radar tile: make the WeatherMap fill (and clip to) its card instead
    of the component's fixed 600px height, which otherwise bleeds past the tile. */
 .hs-weather-tile > div {
  height: 100% !important;
 }
 .hs-weather-tile .map-container {
  height: 100% !important;
  border-radius: 0;
 }
h2 {
    font-size: 0.8em;
  }

  h1 {
    color: #0B2A1B;
    font-weight: bold;
  }

  .ant-col {
    padding: 0.25rem;
  }
 
  @media only screen and (max-width: 768px) {
    #breed-chart,
    #sex-chart,
    #temperature-chart,
    #raining-chart,
    #my_dataviz,
    #livestock_age_weight_chart {
      pointer-events: none;
    }
  }

  .chart-block {
    position: relative;
  }

  .sample-text {
    position: absolute;
    top: 50%;
    left: 20%;
    font-size: 1rem;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #0B2A1B;
  }

  .reload-button {
    color: #0B2A1B;
    padding: 5px 8px;
  }
  .reload-button .anticon-sync {
    line-height: 0;
  }
  .leaflet-container {
    z-index: 1;
  }
  .statistic-card {
    background: #ffffff;

    /* Primary/Light Grey */
    padding: 10px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    box-shadow: 1px 1px 10px rgba(229, 229, 229, 0.6);
    border-radius: 10px ;
    height: 100%;
  }
  .statistic-cards {
    background: #ffffff;
    /* Primary/Light Grey */

    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    box-shadow: 1px 1px 10px rgba(229, 229, 229, 0.6);
    border-radius: 10px !important;
    height: 100% !important;
  }
  .health-safety-search {
    margin-bottom: 15px;
    @media (max-width: 767px) {
      width: 100%;
      margin-bottom: 10px;
    }
  }
//  td.ant-table-cell{
//     min-width:150px !important;
   
//   }
  .health-safety-search .ant-input-affix-wrapper:not(:last-child) {
    border-radius: 5px;
  }
  .health-safety-search .ant-input-group-addon:last-child {
    left: 5px !important;
    background: transparent;
  }
  .health-safety-search
    .ant-input-group-addon:last-child
    .ant-input-search-button:not(.ant-btn-primary) {
    border-radius: 5px !important;
    background: #0B2A1B;
    color: #ffffff;
  }
  .health-safety-search .ant-input {
    border: 0px !important;
  }
  .health-safety-search .ant-input:focus,
  .health-safety-search .ant-input:active {
    box-shadow: none !important;
    border-color: #0B2A1B !important;
  }
  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
      border-color: #0B2A1B;
      border-right-width: 1px;
      z-index: 1;
  }
  .ant-input-affix-wrapper-focused,
  .ant-input-affix-wrapper-focused:focus{
    border-color:#0B2A1B;
    box-shadow: none !important;
  }

  .ant-input:focus, .ant-input-focused, .ant-select:focus, .ant-select-focused, .ant-input-number-focused, .ant-input-number:focus{
    box-shadow: none !important;
  }

  .health-safety-type-filter {
    width: 200px;
    margin-bottom: 15px;
    @media (max-width: 767px) {
      width: 70%;
    }
  }
  .health-safety-type-filter .ant-select-selector {
    border-radius: 5px !important;
  }
  .health-safety-type-filter .ant-select-selector:focus,
  .health-safety-type-filter .ant-select-selector:active,
  .health-safety-type-filter .ant-select-focused .ant-select-selector,
  .health-safety-type-filter .ant-select-selector:focus-within {
    box-shadow: none !important;
    border-color: #0B2A1B !important;
  }
  #health-safety-chart,
  #health-safety-map {
    height: 500px;
  }
  // .ant-pagination-item-active a {
  //   color: #5e8c5;
  // }
  .ant-table-cell a {
    color: #0B2A1B;
  }
  .ant-pagination-item a:hover {
    color: #0B2A1B;
  }
  .ant-pagination-item-active {
    border-color: #0B2A1B;
  }
  .ant-table-column-sorter-up.active,
  .ant-table-column-sorter-down.active {
    color: #0B2A1B;
  }
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    color: #0B2A1B;
  }
  .maps_rows{
    margin-top:10px;
    .ctm-health {
      .ant-card{
        border-radius:10px;
        .ant-card-body{
          padding:10px;
          border-radius:10px;
        }
      }
    }
    .statistic-card{
      height:100% !important;
    }
  }
  .trafficLight_custom{
    >div:nth-child(2){
      // height: calc(100% - 145px);
      >div{
        height:100%;
      }
    }
  }
  @media only screen and (max-width: 1199px){
    .maps_rows{
      margin-top:0;
      .statistic-card{
        height:500px !important;
      }
    }
    .trafficLight_custom{
      > div:nth-child(2){
        height:auto !important;
      }
    }
  }
  @media (max-width: 767px) {
    #health-safety-chart,
    #health-safety-map {
      height: 350px;
    }
  }
  @media only screen and (width :1440px){
   
  }
`;

export default WithDirection(HealthSafetyWrapper);
